/**
 * 추가폰 등록 기능 설정 파일
 */

// Firebase 경로 정의
export const ACCOUNT_SYNC_PATHS = {
  ACCOUNT_GROUPS: 'accountGroups',
  PHONE_TO_GROUP: 'phoneToGroup',
  SYNC_HISTORY: 'accountSyncHistory',
} as const;

// 그룹 설정 기본값
export const DEFAULT_GROUP_SETTINGS = {
  MAX_GROUP_SIZE: 5,              // 최대 그룹 멤버 수
  AUTO_SYNC_EXPIRE_DATE: true,    // 만료일 자동 동기화
  NOTIFY_ON_CHANGE: false,        // 변경 시 알림
  MIN_SEARCH_LENGTH: 4,           // 최소 검색 문자 수
  CACHE_TTL: 300000,              // 캐시 유효 시간 (5분)
  RETRY_ATTEMPTS: 3,              // 재시도 횟수
  RETRY_DELAY: 1000,              // 재시도 지연 시간 (ms)
} as const;

// 에러 메시지 정의
export const ERROR_MESSAGES = {
  E001: '권한이 없습니다. SuperMaster 권한이 필요합니다.',
  E002: '그룹 크기를 초과했습니다. 최대 5개까지 추가 가능합니다.',
  E003: '순환 참조가 감지되었습니다.',
  E004: '이미 다른 그룹에 속해있는 전화번호입니다.',
  E005: '트랜잭션 처리 중 오류가 발생했습니다.',
  E006: '네트워크 오류가 발생했습니다. 다시 시도해주세요.',
  E007: '그룹을 찾을 수 없습니다.',
  E008: '유효하지 않은 전화번호 형식입니다.',
} as const;

// UI 텍스트 정의
export const UI_TEXTS = {
  BUTTON_ADD_PHONE: '추가폰 등록',
  BUTTON_SEARCH: '검색',
  BUTTON_REGISTER: '등록',
  BUTTON_CANCEL: '취소',
  BUTTON_DELETE: '삭제',
  
  LABEL_PHONE_SEARCH: '전화번호 검색',
  LABEL_LINKED_PHONES: '추가폰 목록',
  LABEL_GROUP_INFO: '그룹 정보',
  
  PLACEHOLDER_SEARCH: '전화번호 일부 입력 (최소 4자리)',
  
  CONFIRM_DELETE: '정말로 이 추가폰을 삭제하시겠습니까?',
  CONFIRM_REMOVE_GROUP: '전체 그룹을 삭제하시겠습니까?',
  
  SUCCESS_ADD: '추가폰이 성공적으로 등록되었습니다.',
  SUCCESS_REMOVE: '추가폰이 삭제되었습니다.',
  SUCCESS_SYNC: '만료일이 동기화되었습니다.',
  
  INFO_NO_RESULTS: '검색 결과가 없습니다.',
  INFO_ALREADY_IN_GROUP: '이미 그룹에 속해있습니다.',
  INFO_MAX_GROUP_SIZE: `최대 ${DEFAULT_GROUP_SETTINGS.MAX_GROUP_SIZE}개까지 추가 가능합니다.`,
} as const;

// 권한 설정
export const PERMISSION_CONFIG = {
  REQUIRED_GRADE: 'supermaster',  // 필요한 사용자 등급
  ALLOW_SELF_MANAGEMENT: false,   // 자신의 그룹 관리 허용 여부
  REQUIRE_CONFIRMATION: true,      // 중요 작업 시 확인 필요
} as const;

// 성능 설정
export const PERFORMANCE_CONFIG = {
  BATCH_SIZE: 10,                 // 배치 처리 크기
  PAGINATION_SIZE: 20,            // 페이지네이션 크기
  DEBOUNCE_DELAY: 300,           // 디바운스 지연 시간 (ms)
  MAX_CACHE_SIZE: 100,            // 최대 캐시 크기
} as const;